import { useHomeText } from '../text';

const Schools = () => {
  const t = useHomeText();
  return (
    <section id="schools" style={{ background: "#E2F7F3" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "104px 24px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(480px, 100%), 1fr))", gap: "48px", alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
          <span style={{ fontWeight: "700", color: "#145E55", fontSize: "16px" }}>
            {t.schools.forSchoolsAndInstitutions}
          </span>
          <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(32px, 3.8vw, 48px)", lineHeight: "1.2" }}>
            {t.schools.aPlatformThatAdapts}
          </h2>
          <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#2E4A47" }}>
            {t.schools.withAFlexibleContent}
          </p>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            <a href="#contact" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 24px", borderRadius: "18px", background: "#0B1240", color: "#FFFFFF", fontWeight: "800", textDecoration: "none" }}>
              {t.schools.requestADemoFor}
            </a>
            <a href="#contact" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 24px", borderRadius: "18px", border: "2px solid #0B1240", color: "#0B1240", fontWeight: "800", textDecoration: "none" }}>
              {t.schools.downloadTheBrochure}
            </a>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(240px, 100%), 1fr))", gap: "14px" }}>
          <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
            <strong style={{ fontSize: "18px" }}>
              {t.schools.customisableContent}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.schools.modulesAddedToFit}
            </span>
          </div>
          <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
            <strong style={{ fontSize: "18px" }}>
              {t.schools.classTracking}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.schools.toBeConfirmedA}
            </span>
          </div>
          <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
            <strong style={{ fontSize: "18px" }}>
              {t.schools.multilingual}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.schools.arabicFrenchAndEnglish}
            </span>
          </div>
          <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
            <strong style={{ fontSize: "18px" }}>
              {t.schools.trainingAndSupport}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.schools.weSupportTeachersIn}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schools;
